import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import React, { useContext, useMemo, useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import ErrorIcon  from "@mui/icons-material/ErrorOutline";
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import useResponsive from '../../hooks/useResponsive';
import successIcon from '../../media/success_icon.png';


const loginInitialValue = {
  tel: '',
  Country: '',
  password: '',
  confirmPassword: '',
  otp: '',
};
const ForgotPassword = ({ setForgotPassword }) => {
  const [info, setInfo] = useState({
    message: '',
    color: '',
  });
  const [verificationStage, setVerificationStage] = useState('');
  const [userData, setUserData] = useState({});
  const [blockedCustomerDialogOpen, setBlockedCustomerDialogOpen] = useState(false);
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisibility((prev) => !prev);
  const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisibility((prev) => !prev);

  const ValidationSchema = useMemo(
    () =>
      Yup.object({
        otp: Yup.string().length(4, 'OTP is required and must be 4 digits'),
        password: Yup.string()
          .min(6, 'Password must be at least 6 characters long')
          .max(15, 'Password cannot exceed 15 characters')
          .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
          .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
          .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
          .required('Password is required'),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref('password')], 'Passwords must match')
          .required('Please confirm your password'),
        Country: Yup.string().required('Country of origin is required'),
        tel: Yup.string()
          .required('Contact number is required')
          .matches(/^\d+$/, 'Contact number must contain only digits')
          .min(9, 'Contact number must be at least 9 digits')
          .max(15, 'Contact number must not exceed 15 digits'),
        // tel: Yup.string().required('Phone number is required').min(9, 'Invalid phone number length'),
      }),
    []
  );
  async function VerifyExistingUser(Phone) {
    try {
      showLoading();
      const response = await axios.post('signup/VerifyExistingUser', { Phone });
      if (response.data[0].IsBlocked === 'Y' || response.data[0].Active === 'N') setBlockedCustomerDialogOpen(true);
      else if (response.data[0].WebAccess === 'N') handleInfo('User Not Found', 'error');
      else if (response.data[0].WebAccess === 'P') handleInfo('Approval Pending.. ', 'error');
      else {
        setInfo({ message: '', color: '' });
        setUserData(response.data[0]);
        setVerificationStage('sendotp');
      }
    } catch {
      handleInfo('Invalid Phone Number', 'error');
    }
    hideLoading();
  }

  const sendOtp = async () => {
    try {
      showLoading();
      const response = await axios.post('signup/sendOtp', {
        Email: userData?.EmailId,
        isForgotPassword: 'Y',
      });
      openSnackBar('Otp Has Been Sent Successfully!, Please check Your Email', 'success');
      setInfo({ message: '', color: '' });
      setVerificationStage('verifyotp');
    } catch (e) {
      handleInfo('Invalid Phone Number', 'error');
    }
    hideLoading();
  };

  async function verifyOtp(Otp) {
    try {
      showLoading();
      await axios.post('signup/verifyOtp', {
        Email: userData?.EmailId,
        Otp,
      });
      setVerificationStage('completed');
      setInfo({ message: '', color: '' });
    } catch (e) {
      handleInfo('Invalid OTP, please try again.', 'error');
    }
    hideLoading();
  }

  async function forgotPassword(Password) {
    try {
      showLoading();
      await axios.post('signup/forgotPassword', {
        EmailId: userData?.EmailId,
        Password,
        CustomerId: userData.CustomerId,
      });
      setInfo({ message: '', color: '' });
      setVerificationStage('passwordChanged');
    } catch (e) {
      handleInfo('Something went Wrong , Try again after some times', 'error');
    }
    hideLoading();
  }

  const handleOriginHeader = (e, handleChange) => {
    axios.defaults.headers.country = e.target.value;
    sessionStorage.setItem('country', e.target.value);
    handleChange(e);
  };

  const handleInfo = (message, color) => {
    setInfo({ message, color });
    setTimeout(() => {
      setInfo({ message: '', color: '' });
    }, 3000);
  };

  return (
    <>
      <Formik
        validationSchema={ValidationSchema}
        context={{ Country: 'IN' }}
        initialValues={loginInitialValue}
        onSubmit={null}
      >
        {({ values, errors, isSubmitting, handleBlur, handleChange, setFieldValue, touched }) => (
          <Form>
            <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
              {info.message && !userData?.EmailId && (
                <Grid item xs={12}>
                  <Typography variant="body2" color={info.color} sx={{ textAlign: 'center' }}>
                    {info.message}
                  </Typography>
                </Grid>
              )}
              {!verificationStage && (
                <>
                  <Grid item xs={12}>
                    <FormControl fullWidth size="small" fullwidth>
                      <InputLabel id="Country-select-label">Country of Origin</InputLabel>
                      <Select
                        fullWidth
                        labelId="Country-select-label"
                        value={values.Country}
                        size="small"
                        name="Country"
                        label="Country of Origin"
                        onChange={(e) => {
                          handleOriginHeader(e, handleChange);
                        }}
                        error={touched.Country && !!errors.Country}
                      >
                        <MenuItem value="IN">INDIA</MenuItem>
                        <MenuItem value="UK">UNITED KINGDOM</MenuItem>
                        <MenuItem value="SL">SRILANKA</MenuItem>
                      </Select>
                      {touched.Country && errors.Country && (
                        <Grid item xs={12}>
                          <Typography variant="caption" color="error" className="shake-helper-text" margin="0 0 0 14px">
                            {errors.Country}
                          </Typography>
                        </Grid>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Contact No"
                      type="text"
                      name="tel"
                      onBlur={handleBlur}
                      error={touched.tel && !!errors.tel}
                      helperText={touched.tel && errors.tel ? errors.tel : ''}
                      value={values.tel}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/[^0-9]/g, '');
                        handleChange({ target: { name: 'tel', value: numericValue } });
                      }}
                      // onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      onClick={() => {
                        if (touched.tel && !errors.tel) VerifyExistingUser(values.tel);
                      }}
                      disabled={isSubmitting}
                      variant="contained"
                      color="primary"
                      size="small"
                      fullWidth
                      sx={{ boxShadow: 1 }}
                    >
                      Next
                    </Button>
                  </Grid>
                </>
              )}
              {verificationStage !== '' && verificationStage !== 'completed' && (
                <Stack justifyContent={'center'} alignItems={'center'} direction={'column'} spacing={2}>
                  {verificationStage === 'completed' ? (
                    <Typography variant="body1" color="success.main">
                      OTP verified! You can proceed to the next step.
                    </Typography>
                  ) : verificationStage === 'verifyotp' ? (
                    <Typography variant="body1" color="text.secondary" gutterBottom textAlign="center" sx={{ px: 10 }}>
                      We've sent an OTP to{' '}
                      <strong style={{ color: 'green', marginLeft: 3 }}>{userData?.EmailId}</strong>. Please enter the
                      OTP below to verify your email and continue.
                    </Typography>
                  ) : (
                    <Typography variant="body1" color="text.secondary" gutterBottom textAlign="center" sx={{ px: 10 }}>
                      For security purposes, an OTP will be sent to
                      <strong style={{ color: 'green', marginLeft: 3 }}>{userData?.EmailId}</strong>, click the 'Send
                      OTP' button below to initiate the verification process.
                    </Typography>
                  )}

                  {verificationStage === 'sendotp' && (
                    <Button variant="outlined" color="success" onClick={sendOtp}>
                      Send OTP
                    </Button>
                  )}

                  {verificationStage === 'verifyotp' && (
                    <>
                      {/* OTP Input Field */}
                      <TextField
                        size="small"
                        label="Enter OTP"
                        type="text"
                        name="otp"
                        value={values.otp}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.otp && !!errors.otp}
                        helperText={touched.otp && errors.otp ? errors.otp : ''}
                      />
                      <Typography
                        align="right"
                        variant="body2"
                        color="primary"
                        sx={{ cursor: 'pointer' }}
                        onClick={() => {
                          setFieldValue('otp', '');
                          sendOtp();
                        }}
                      >
                        Re-send OTP
                      </Typography>

                      {/* Verify OTP Button */}
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (touched.otp && !errors.otp) verifyOtp(values.otp);
                        }}
                      >
                        Verify OTP
                      </Button>
                    </>
                  )}
                  {info.message && userData?.EmailId && (
                    <Typography variant="caption" color={info.color}>
                      {info.message}
                    </Typography>
                  )}
                </Stack>
              )}
              {verificationStage === 'completed' && (
                <>
                  <Grid item xs={12}>
                    <Stack justifyContent="center" alignItems="center" spacing={3}>
                      {/* Thank You and Username Display */}
                      <Typography variant="h6" color="primary">
                        Your request accepted , change your password
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <Stack direction="column" justifyContent="center" gap={2} width={'100%'}>
                      <TextField
                        size="small"
                        fullWidth
                        name="password"
                        label="New Password"
                        type={passwordVisibility ? 'text' : 'password'}
                        autoComplete="off"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!errors.password && touched.password}
                        helperText={touched.password && errors.password ? errors.password : ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={togglePasswordVisibility} edge="end">
                                {passwordVisibility ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <TextField
                        size="small"
                        fullWidth
                        name="confirmPassword"
                        label="Confirm Password"
                        type={confirmPasswordVisibility ? 'text' : 'password'}
                        autoComplete="off"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!errors.confirmPassword && touched.confirmPassword}
                        helperText={touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword : ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleConfirmPasswordVisibility} edge="end">
                                {confirmPasswordVisibility ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (
                            touched.confirmPassword &&
                            !errors.confirmPassword &&
                            touched.password &&
                            !errors.password
                          )
                            forgotPassword(values.password);
                        }}
                      >
                        Change Password
                      </Button>
                    </Stack>
                  </Grid>
                </>
              )}
            </Grid>
          </Form>
        )}
      </Formik>
      <Button
        onClick={() => {
          setForgotPassword(false);
        }}
      >
        back to login
      </Button>
      <Dialog open={verificationStage === 'passwordChanged'} onClose={() => {}} maxWidth="sm" fullWidth>
        <DialogContent dividers>
          <img width={80} style={{ display: 'block', margin: 'auto' }} src={successIcon} alt="success icon" />
          <Typography variant="body2" sx={{ textAlign: 'center', marginBottom: 2 }}>
            Your password has been successfully changed. You can now log in using your new password.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box display="flex" justifyContent="center" width="100%">
            <Button onClick={() => setForgotPassword(false)} variant="contained" color={'success'} size="small">
              Back to Login
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      
<Dialog
  open={blockedCustomerDialogOpen}
  onClose={() => {}}
  maxWidth="xs"
  fullWidth
  PaperProps={{ sx: { borderRadius: 3 } }}
>
  <DialogContent sx={{ textAlign: "center", pt: 4, px: 4 }}>
    {/* Error Icon */}
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 64,
        height: 64,
        borderRadius: "50%",
        bgcolor: "#fee2e2",
        mb: 2,
      }}
    >
      <ErrorIcon sx={{ fontSize: 34, color: "#ef4444" }} />
    </Box>

    <Typography variant="h6" fontWeight={700} gutterBottom>
      Something Went Wrong
    </Typography>

    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
      Please contact Support for assistance.
    </Typography>
  </DialogContent>

  <DialogActions sx={{ px: 4, pb: 3 }}>
    <Button
      onClick={() => setBlockedCustomerDialogOpen(false)}
      variant="contained"
      fullWidth
      autoFocus
      sx={{
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 600,
        bgcolor: "#ef4444",
        "&:hover": { bgcolor: "#dc2626" },
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>
    </>
  );
};

export default ForgotPassword;
